import type { ActivityComponentType } from '@stackflow/react';
import NewChannelPage from '@/features/messaging/pages/NewChannelPage';

const NewChannelActivity: ActivityComponentType = () => {
  return <NewChannelPage />;
};

export default NewChannelActivity;
